export const pause_circle = () => (
  <path
    d="M10 15V9m4 6V9m8 3c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
